import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { User } from '@app/objects/User';
import { ApplicationState } from '@app/store';
import { AppRoute, PetProfileTab } from '@app/utils/appRoutes';

const AuthWatcher: React.FC = () => {
	const login = useSelector((state: ApplicationState) => state.login, shallowEqual);
	const navigate = useNavigate();
	const previousUser = React.useRef<User | null>(login.user);

	React.useEffect(() => {
		const user = login.user;
		const hasLoggedIn = !previousUser.current && user;

		if (hasLoggedIn) {
			if (user.defaultPetId && user.defaultPetId > 0) {
				navigate(`${AppRoute.PET_PROFILE}/${user.defaultPetId}/${PetProfileTab.DASHBOARD}`);
			} else {
				navigate(AppRoute.PETS);
			}
		}

		previousUser.current = user;
	}, [login.user, navigate]);

	return null;
};

export default AuthWatcher;
